"use client"

import Image from 'next/image';
import logo_dark from '../img/logo_dark.svg';
import Link from "next/link";
import Menu from "../../src/apps/front/components/Menu";
import {Mail, Phone} from "lucide-react";
import linkedin from '../img/linkedin.svg';
import facebook from '../img/facebook.svg';

export default function FooterClient({dict, GlobalFields, menu1, menu2}) {
    const iconLinks = [
        {
            href: 'tel:' + GlobalFields.find(field => field.slug === 'phone')?.value.replace('+', '00').replace(/\s+/g, ''),
            text: GlobalFields.find(field => field.slug === 'phone')?.value,
            icon: <Phone className="size-3.5 text-blue-500"/>
        },
        {
            href: 'mailto:' + GlobalFields.find(field => field.slug === 'email')?.value,
            text: GlobalFields.find(field => field.slug === 'email')?.value,
            icon: <Mail className="size-3.5 text-blue-500"/>
        },
        {
            href: GlobalFields.find(field => field.slug === 'linkedin_url')?.value,
            text: GlobalFields.find(field => field.slug === 'linkedin_name')?.value,
            icon: <Image src={linkedin} className="size-3 text-blue-500" alt="linkedin icon"/>
        },
        {
            href: GlobalFields.find(field => field.slug === 'facebook_url')?.value,
            text: GlobalFields.find(field => field.slug === 'facebook_name')?.value,
            icon: <Image src={facebook} className="size-3.5 text-blue-500" alt="facebook icon"/>
        }
    ]
    return (
        <footer className="bg-inverse mt-10 lg:mt-44">
            <div className="px-6 lg:px-4 pt-22 py-14 lg:py-30 max-w-(--container-width) mx-auto">
                <div className="flex flex-wrap gap-10 lg:justify-between relative">
                    <div className="w-full flex justify-center lg:w-[initial]">
                        <div className="w-fit">
                            <Image
                                src={logo_dark}
                                width={190}
                                height={48}
                                alt="logo dark"
                                className="md:w-[260px] md:h-[68px]"
                            />
                            <p className="text-muted-inverse text-footer-tag mt-1.5 md:mt-2">{dict.footer.perex}</p>
                        </div>
                    </div>
                    <div className="w-(--footer-half-width) md:w-(--footer-third-width) lg:w-[initial]">
                        <Menu
                            items={menu1.translations[0].items}
                            className="text-body-inverse text-heading-3 gap-6 lg:gap-4 flex flex-col"
                            linkClassName="hover:underline"
                            itemClassName=""
                        />
                    </div>
                    <div className="w-(--footer-half-width) md:w-(--footer-third-width) lg:w-[initial]">
                        <p className="text-body-inverse text-heading-3 mb-2.5">{dict.footer.download}</p>
                        <Menu
                            items={menu2.translations[0].items}
                            className="text-muted-inverse text-small gap-4 lg:gap-2.5 flex flex-col lg:text-t-d-small "
                            linkClassName="underline hover:no-underline"
                            itemClassName="text-body-inverse"
                        />
                    </div>
                    <div
                        className="flex flex-col gap-6 lg:gap-4 text-body-inverse text-heading-3 text-center items-start w-full md:w-(--footer-third-width) lg:w-[initial] lg:absolute lg:left-0 lg:bottom-0 cxl:relative cxl:left-[initial] cxl:bottom-[initial]">
                        {iconLinks.map((link, index) => (
                            <Link
                                key={index}
                                className="flex items-center gap-2.5 hover:underline"
                                target="_blank"
                                href={link.href}>
                                <span
                                    className="border-1 size-7 flex items-center justify-center rounded-full border-blue-300">
                                    {link.icon}
                                </span>
                                {link.text}
                            </Link>
                        ))}
                    </div>
                </div>
                <div
                    className="border-t border-body mt-10 pt-10 text-small font-medium text-muted-inverse lg:text-lg lg:pt-13 lg:mt-13">© {new Date().getFullYear()} EMERGE
                    group
                </div>
            </div>
        </footer>
    )
}